import { isValidSelectorString } from '@/utils/validations/selector.validation';
import { z } from 'zod';
import { ExtendedTarificationSchema } from './tarification/TarificationFormData';
import { MarginRateSchema } from '../common/margin-rate.schema';

export const ActivitySchema = ExtendedTarificationSchema.extend({
  name: z.string({ message: 'Le nom est requis' }),
  supplier: isValidSelectorString('Le fournisseur est requis'),
  currency: isValidSelectorString('La devise est requise'),
  country: isValidSelectorString('Le pays est requis'),
  city: isValidSelectorString('La ville est requise').optional(),
  marginRate: MarginRateSchema.optional(),
  shortDescription: z.string().optional(),
  longDescription: z.string().optional(),
  images: z.array(z.union([z.instanceof(Blob), z.string()])),
}).superRefine((data, ctx) => {
  if (data.customTarif === 'true') {
    data.tarifs.forEach((tarif, tarifIndex) => {
      tarif.pricePartitions.forEach((partition, partitionIndex) => {
        if (
          partition.specialPrice === undefined ||
          partition.specialPrice === null ||
          !partition.specialPrice
        ) {
          ctx.addIssue({
            code: 'invalid_type',
            expected: 'number',
            received: 'undefined',
            path: [
              'tarifs',
              tarifIndex,
              'pricePartitions',
              partitionIndex,
              'specialPrice',
            ],
            message: 'Le tarif est requis',
          });
        }
      });
    });
  }
});

export type ActivityFormData = z.infer<typeof ActivitySchema>;
